// extracted by mini-css-extract-plugin
export default {"main":"ingredient-page_main__5Wq2T"};